/*
 * KDS Wishlist — single source of truth for saved items (localStorage).
 * window.KDSWishlist is the ONE canonical store. All UI (PDP button, product
 * cards, header count, wishlist page) reads/writes only through it.
 *
 * Guest: works immediately, persists across navigation/refresh/session/return.
 * Logged-in: same store today; architected so a server-backed provider can be
 *   swapped in later (see PROVIDER seam) WITHOUT changing any UI code.
 *
 * Identity: products are keyed by product.handle (never DOM position/title).
 * Performance: idempotent boot (guarded), ONE delegated click listener on
 *   document, no observers, no polling, no network. Safe to include twice.
 */
(function () {
  'use strict';

  // ── Idempotency guard: the script is referenced from both the header and the
  //    product buy-buttons block, so it can load twice on a PDP. Without this
  //    guard, boot() would attach a SECOND document click listener and every
  //    heart toggle would fire twice (cancelling out — "button does nothing").
  if (window.KDSWishlist && window.KDSWishlist.__booted) return;

  var KEY = 'kds_wishlist_v1';
  var EVT = 'kds:wishlist:change';

  function read() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(v) ? v : [];
    } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    document.dispatchEvent(new CustomEvent(EVT, { detail: { list: list } }));
  }
  function has(handle) { return read().indexOf(handle) !== -1; }
  function add(handle) { if (!handle) return; var l = read(); if (l.indexOf(handle) === -1) { l.unshift(handle); write(l); } }
  function remove(handle) { if (!handle) return; write(read().filter(function (h) { return h !== handle; })); }
  function toggle(handle) { if (!handle) return false; if (has(handle)) { remove(handle); return false; } add(handle); return true; }
  function count() { return read().length; }
  function clear() { write([]); }

  var KDSWishlist = window.KDSWishlist || {};
  KDSWishlist.read = read; KDSWishlist.has = has; KDSWishlist.add = add;
  KDSWishlist.remove = remove; KDSWishlist.toggle = toggle; KDSWishlist.count = count;
  KDSWishlist.clear = clear; KDSWishlist.key = KEY; KDSWishlist.event = EVT;
  window.KDSWishlist = KDSWishlist;

  /* ---- Header count badge ---- */
  function paintCount() {
    var n = count();
    document.querySelectorAll('[data-kds-wishlist-count]').forEach(function (el) {
      el.textContent = n;
      el.style.display = n > 0 ? '' : 'none';
    });
  }

  /* ---- Heart buttons: reflect saved state + a11y labels ---- */
  function paintButtons() {
    document.querySelectorAll('[data-kds-wish-btn]').forEach(function (btn) {
      var handle = btn.getAttribute('data-handle');
      if (!handle) return;
      var on = has(handle);
      btn.classList.toggle('is-wished', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      var label = on ? 'Remove from wishlist' : 'Add to wishlist';
      btn.setAttribute('aria-label', label);
      btn.setAttribute('title', label);
      var lbl = btn.querySelector('[data-wish-add]');
      if (lbl) {
        var a = lbl.getAttribute('data-wish-add'), r = lbl.getAttribute('data-wish-remove');
        if (a && r) lbl.textContent = on ? r : a;
      }
    });
  }
  KDSWishlist.paint = function () { paintCount(); paintButtons(); };

  /* ---- ONE delegated click handler for every heart, anywhere ----
     Delegation means dynamically-inserted cards (collection filter/sort,
     Horizon section re-render) work with no re-binding and no duplicate
     listeners. stopPropagation stops the card's product link from firing. */
  function onClick(e) {
    var btn = e.target.closest('[data-kds-wish-btn]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    toggle(btn.getAttribute('data-handle'));
    paintButtons();
  }

  function boot() {
    paintCount();
    paintButtons();
    document.addEventListener('click', onClick);
    document.addEventListener(EVT, function () { paintCount(); paintButtons(); });
    window.addEventListener('storage', function (e) { if (e.key === KEY) { paintCount(); paintButtons(); } });
    document.addEventListener('shopify:section:load', function () { paintCount(); paintButtons(); });
    KDSWishlist.__booted = true;
  }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', boot) : boot();
})();
